import { FC } from 'react'
import { Card } from '@cmsgov/ds-medicare-gov'
import { BillInfo } from '@cms-max/medicare-api-sdk'
import { PremiumBillCardInfo } from './PremiumBillCardInfo'
import { PremiumBillCardCosts } from './PremiumBillCardCosts'
import classes from './PremiumBillCard.module.scss'

export interface PremiumBillCardProps {
  bill: BillInfo
  className?: string
}

export const PremiumBillCard: FC<PremiumBillCardProps> = ({ bill, className }) => {
  return (
    <Card className={`${className} ${classes.premiumBillCardSummary} ds-u-flex-direction--column ds-u-md-flex-direction--row`}>
      <div className='ds-l-row ds-u-padding--3'>
        <div className='ds-l-col--6'>
          <PremiumBillCardInfo bill={bill} />
        </div>
        <div className='ds-l-col--6'>
          <PremiumBillCardCosts bill={bill} />
        </div>
      </div>
    </Card>
  )
}
